module.exports = __webpack_public_path__ + "img/spoon.59d42054.svg";